import {LoaderFunctionArgs} from 'react-router-dom';
import {getAppTracer} from '../../../app.tracer';
import {
    IEmbeddedDashboardGeneralErrorStore,
    EmbeddedDashboardGeneralErrorStore
} from './embedded-dashboard-general-error.stores';

const trace = getAppTracer('embedded-dashboard-general-error.loader');

export async function embeddedDashboardGeneralErrorRouteLoader(
    _args: LoaderFunctionArgs
): Promise<IEmbeddedDashboardGeneralErrorStore> {
    trace.info('Starting');
    const store = new EmbeddedDashboardGeneralErrorStore();
    trace.info('Completed successfully');
    return store;
}
